module.exports = __webpack_public_path__ + "img/BN.b1b88485.png";